
import { Component, Vue } from 'vue-property-decorator';
import { appName } from '@/env';
import { dispatchPasswordRecovery } from '@/store/main/actions';
import ApplicationFooter from '@/components/ApplicationFooter.vue';
import { saveState } from '@/utils';

@Component({
  components: {
    ApplicationFooter,
  },
})
export default class PasswordRecovery extends Vue {
  public valid = true;
  public user_email: string = '';
  public appName = appName;

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    if (await this.$validator.validateAll()) {
      dispatchPasswordRecovery(this.$store, { user_email: this.user_email });
    }
  }

  public async googleLogin() {
    saveState('callback-login');
    this.$router.push('/google-callback');
  }

  get isComplete() {
    return this.user_email;
  }
}
